/**
 * Plain object Packlink's API response representation.
 */

class PriceAnatomyMapper {
  static createModelFromResponse(response) {
    const mapPriceDetail = priceDetail => ({
      basePrice: priceDetail.base_price || undefined,
      taxPrice: priceDetail.tax_price || undefined,
      totalPrice: priceDetail.total_price || undefined,
      currency: priceDetail.currency || undefined
    });
    return {
      serviceId: response.service_id,
      price: {
        ...mapPriceDetail(response.price),
        items: response.price.items.map(priceItem => ({
          ...mapPriceDetail(priceItem),
          concept: priceItem.concept || undefined,
          extraData: priceItem.extra_data || undefined
        }))
      }
    };
  }
}

export { PriceAnatomyMapper };
//# sourceMappingURL=PriceAnatomyMapper.js.map
